import * as _ from "../../../util/lodash";
import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import cx from 'classnames';
import { whitelistStyles } from "../../core/hoc";
import { icons, positions } from "../../../enums";
import ContentCardHeader from "./content-card-header";
import ContentCardBody from "./content-card-body";
import ContentCardMedia from "./content-card-media";
import ContentCardMediaMain from "./content-card-media-main";
import ContentCardAvatar from "./content-card-avatar";
import ContentCardActions from "./content-card-actions";
import ContentCardDetails from "./content-card-details";
var ContentCard = createComponent({
  displayName: 'ContentCard',
  propTypes: {
    isSelected: PropTypes.bool,
    isActive: PropTypes.bool,
    avatar: PropTypes.oneOfType([PropTypes.element, PropTypes.shape({
      imageSrc: PropTypes.string,
      userName: PropTypes.string,
      userHandle: PropTypes.string,
      network: PropTypes.string,
      timestamp: PropTypes.string
    })]),
    bodyText: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    mediaMain: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    mediaMainPosition: PropTypes.oneOf([positions.TOP, positions.BOTTOM]),
    media: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.arrayOf(PropTypes.element), PropTypes.arrayOf(PropTypes.string)]),
    actions: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.shape({
      icon: PropTypes.oneOf(icons.ALL),
      onClick: PropTypes.func,
      tooltip: PropTypes.string
    }))]),
    details: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.shape({
      icon: PropTypes.oneOf(icons.ALL),
      onClick: PropTypes.func,
      tooltip: PropTypes.string
    }))]),
    onClick: PropTypes.func,
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)])
  },
  defaultProps: {
    isSelected: false,
    isActive: false,
    avatar: undefined,
    bodyText: undefined,
    media: undefined,
    mediaMain: undefined,
    mediaMainPosition: positions.BOTTOM,
    actions: undefined,
    children: undefined,
    details: undefined,
    onClick: _.noop
  },
  contextTypes: {
    isInverted: PropTypes.bool
  },
  handlers: {
    handleClick: function handleClick(p) {
      return function (ev) {
        p.onClick(ev);
      };
    }
  },
  render: function render(p) {
    var _cx = cx({
      ck: true,
      'content-card': true,
      'content-card--selected': p.isSelected,
      'content-card--inverted': p.isInverted,
      'content-card--active': p.isActive
    });

    var isMediaSingleItem = p.media && _.isArray(p.media) ? p.media.length === 1 : [p.media].length === 1;
    var invertActions = p.isSelected ? false : p.isInverted;
    return /*#__PURE__*/React.createElement("div", {
      className: _cx,
      style: p.style
    }, /*#__PURE__*/React.createElement("div", {
      onClick: p.handleClick,
      className: "content-card__inner"
    }, /*#__PURE__*/React.createElement(ContentCardHeader, null, /*#__PURE__*/React.createElement(ContentCardAvatar, null, p.avatar), /*#__PURE__*/React.createElement(ContentCardActions, {
      isInverted: invertActions
    }, p.actions)), p.mediaMainPosition === positions.TOP ? /*#__PURE__*/React.createElement(ContentCardMediaMain, null, p.mediaMain) : null, /*#__PURE__*/React.createElement("div", {
      className: "content-card__main"
    }, p.bodyText ? /*#__PURE__*/React.createElement(ContentCardBody, null, p.bodyText) : null, p.media && !p.mediaMain && isMediaSingleItem ? /*#__PURE__*/React.createElement(ContentCardMedia, null, p.media) : null), p.mediaMainPosition !== positions.TOP ? /*#__PURE__*/React.createElement(ContentCardMediaMain, null, p.mediaMain) : null, p.media && !isMediaSingleItem ? /*#__PURE__*/React.createElement(ContentCardMedia, null, p.media) : null, p.children, p.details ? /*#__PURE__*/React.createElement(ContentCardDetails, null, p.details) : null));
  }
});
export default whitelistStyles()(ContentCard);
//# sourceMappingURL=content-card.js.map